export default __webpack_public_path__ + "media/assets/img/expand-more-blue-78cba18788259ab3439a9bdc57de0bcf.svg";